import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/location"

export const getSystemLocations = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const getSystemLocation = async locationId => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/${locationId}`)

  return response.data
}

export const addSystemLocation = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const editSystemLocation = async (locationId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${locationId}`, data)

  return response.data
}

export const deleteSystemLocation = async locationId => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.delete(`${endpoint}/${locationId}`)

  return response.data
}